var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgI = function SvgI(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19c-4.8 0-8.7-3.9-8.7-8.7S5.2 1.7 10 1.7s8.7 3.9 8.7 8.7S14.8 19 10 19m0-15.3a6.7 6.7 0 1 0 0 13.4 6.7 6.7 0 0 0 0-13.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 7.2c0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2m.1 7.4V9.4H11v5.3H8.9z"
  }))));
};
export default SvgI;